"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToMarkDispose = exports.tryToDispose = exports.toDisposable = exports.combinedDisposable = exports.dispose = exports.isDisposable = void 0;
var dispose_trace_1 = require("./dispose-trace");
var dispose_marktrack_1 = require("./dispose-marktrack");
function isDisposable(thing) {
    return (typeof thing.dispose === 'function'
        && (thing.dispose.length === 0
            || thing.dispose.length === 1));
}
exports.isDisposable = isDisposable;
function dispose(disposables, trace) {
    // disposables为数组,单独清理
    if (Array.isArray(disposables)) {
        var disposablesDisposeTrace_1 = trace || dispose_trace_1.DisposeTrace.traceRoot('disposables');
        disposables.forEach(function (d) {
            if (d) {
                dispose_marktrack_1.markTracked(d);
                d.dispose(disposablesDisposeTrace_1);
            }
        });
        disposablesDisposeTrace_1.stop();
        return [];
    }
    if (disposables) {
        var disposablesDisposeTrace = trace || dispose_trace_1.DisposeTrace.traceRoot('disposables');
        dispose_marktrack_1.markTracked(disposables);
        disposables.dispose(disposablesDisposeTrace);
        disposablesDisposeTrace.stop();
        return disposables;
    }
    return undefined;
}
exports.dispose = dispose;
/**
 * 将多个disposable对象组合为一个diposable对象
 * @param disposables
 */
function combinedDisposable() {
    var disposables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        disposables[_i] = arguments[_i];
    }
    disposables.forEach(dispose_marktrack_1.markTracked);
    return dispose_marktrack_1.trackDisposable({
        dispose: function (trace) { return dispose(disposables, trace); },
    });
}
exports.combinedDisposable = combinedDisposable;
/**
 * 将一个业务自定义的清理函数封装为diposable标准对象
 * @param fn
 * @param disposableName
 */
function toDisposable(fn, disposableName) {
    if (disposableName === void 0) { disposableName = ''; }
    var self = dispose_marktrack_1.trackDisposable({
        dispose: function (trace) {
            dispose_marktrack_1.markTracked(self);
            fn(trace);
        },
        disposableId: disposableName,
    });
    return self;
}
exports.toDisposable = toDisposable;
function tryToDispose(instance, trace) {
    if (instance && isDisposable(instance)) {
        instance.dispose(trace);
    }
}
exports.tryToDispose = tryToDispose;
function tryToMarkDispose(instance) {
    if (isDisposable(instance)) {
        dispose_marktrack_1.markTracked(instance);
    }
}
exports.tryToMarkDispose = tryToMarkDispose;
//# sourceMappingURL=dispose-util.js.map